module.exports = __webpack_public_path__ + "img/T6-B-16.acecb7d0.png";